import { getStyle } from "../../hooks/use-styles";

const HexContentBox = ({ paragraph, className }) => {
  return (
    <div
      className={`font-12-normal-400-lh-14 capitalize ${className || ""}`}
      style={{ color: getStyle("primaryBlack") }}
    >
      {paragraph}
    </div>
  );
};

export default HexContentBox;
